import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

const TEMPERATURE_OPTIONS = Array.from({ length: 21 }, (_, i) => {
    const v = Math.round(i * 10) / 100;
    return { value: v, label: v.toFixed(1) };
});

function snapTemperature(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return 0.7;
    const clamped = Math.min(2, Math.max(0, n));
    return Math.round(clamped * 10) / 10;
}

const TemperatureControl = observer(() => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const value = snapTemperature(chatStore.settings.temperature ?? 0.7);
    const options = useMemo(() => TEMPERATURE_OPTIONS, []);

    return (
        <div
            className={`flex min-w-0 items-center gap-2 text-xs ${
                isDark ? 'text-white/70' : 'text-black/60'
            }`}
        >
            <span
                className={`inline-flex w-3.5 shrink-0 justify-center font-medium ${
                    isDark ? 'text-white/55' : 'text-black/45'
                }`}
                title="Temperature"
            >
                T
            </span>
            <Select
                size="small"
                value={value}
                className={`bananas-composer-select min-w-[72px] flex-1 sm:w-[84px] sm:flex-none ${
                    isDark
                        ? '[&_.ant-select-selector]:!bg-white/5 [&_.ant-select-selector]:!border-white/10 [&_.ant-select-selector]:!shadow-none [&_.ant-select-selection-item]:!text-gray-100 [&_.ant-select-arrow]:!text-white/45 [&_.ant-select-selector]:hover:!border-white/20'
                        : '[&_.ant-select-selector]:!bg-white [&_.ant-select-selector]:!border-black/15 [&_.ant-select-selection-item]:!text-gray-900 [&_.ant-select-arrow]:!text-black/40'
                }`}
                popupClassName={`bananas-composer-dropdown ${
                    isDark ? 'bananas-composer-dropdown--dark' : ''
                }`}
                popupMatchSelectWidth={false}
                getPopupContainer={() => document.body}
                options={options}
                onChange={(v) => {
                    const next = snapTemperature(v);
                    chatStore.settings.temperature = next;
                    chatStore.saveSettings({ temperature: next });
                    chatStore.schedulePersistChatParams();
                }}
            />
        </div>
    );
});

export default TemperatureControl;
